const API_URL = import.meta.env.VITE_BACKEND_API_URL || "";

const documenttype = ["dni", "passport", "other"] as const;

export interface getInvitationByTokenDTO {
  inviteToken: string;
}

export interface ValidateInvitationResponse {
  valid: boolean;
  message?: string;
  residentName?: string;
  apartmentNumber?: string;
  apartmentId?: string;
  buildingName?: string;
  buildingId?: string;
  date?: string;
  numberOfGuests?: number;
}

export interface NameByDocumentDto {
  documentNumber: string;
  documentType: (typeof documenttype)[number];
}

export interface postInvitationAcceptanceDTO {
  inviteToken: string;
  aparmentId: string;
  buildingId: string;
  documentNumber: string;
  documentType: (typeof documenttype)[number];
  firstName: string;
  lastName: string;
}

export interface NameByDocumentResponse {
  firstName: string;
  lastName: string;
}

export interface AcceptInvitationResponse {
  success: boolean;
  message?: string;
}

export const invitationService = {
  async getInvitationByToken(
    dto: getInvitationByTokenDTO
  ): Promise<ValidateInvitationResponse> {
    try {
      const response = await fetch(`${API_URL}/resident/invitations/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dto),
      });
      if (!response.ok) {
        throw new Error("Error fetching tower information");
      }
      return await response.json();
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  },

  async NameByDocument(dto: NameByDocumentDto): Promise<NameByDocumentResponse> {
    try {
      const response = await fetch(`${API_URL}/resident/invitations/name-by-document`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dto),
      });
      if (!response.ok) {
        throw new Error("Error fetching name by document");
      }
      return await response.json();
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  },

  async postInvitationAcceptance(
    dto: postInvitationAcceptanceDTO
  ): Promise<AcceptInvitationResponse> {
    console.log("DTO in service:", dto);
    try {
      const response = await fetch(`${API_URL}/resident/invitations/accept`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dto),
      });
      if (!response.ok) {
        throw new Error("Error accepting invitation");
      }
      return await response.json();
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  },
};
